import { InlineDatePicker } from 'components/form-elements/pickers/InlineDatePicker';
import React, { useContext, useState } from 'react';
import { daysFormat } from 'utils/timeAndDate';
import { useLaundrySchedules } from 'services/laundry/schedules';
import { ShouldRender } from 'components/ShouldRender';
import { Text } from 'components/typography';
import Loader from 'components/loaders/Loader';
import { isBefore } from 'date-fns';
import { useModal } from 'store/modals';
import { LaundryBrikkModalContext } from '../../index';
import { ResourceSelectionSection } from './components/ResourceSelectionSection';
import styles from './styles.module.scss';

export function getDateFromNow(daysFromNow) {
  const now = new Date();
  const result = new Date(now);
  result.setTime(result.getTime() + daysFromNow * 24 * 60 * 60 * 1000);
  result.setMilliseconds(0);
  return result;
}

export const DateSelectionSection = ({ laundryResources }) => {
  const {
    selectedDate,
    selectedEndDate,
    setSelectedDate,
    setSelectedEndDate,
    selectedResource,
  } = useContext(LaundryBrikkModalContext);
  const { laundrySchedules, isLoading } = useLaundrySchedules(
    selectedResource?.id,
  );
  const [error, setError] = useState('');
  const maxDate = getDateFromNow(laundrySchedules?.bookingRule?.notBefore);
  const minDate = getDateFromNow(laundrySchedules?.bookingRule?.notAfter);
  const minDuration = laundrySchedules?.bookingRule?.minDuration;
  const maxDuration = laundrySchedules?.bookingRule?.maxDuration;
  const [tempEndDate, setTempEndDate] = useState(selectedEndDate);
  const [tempStartDate, setTempStartDate] = useState(null);

  const { openModal } = useModal();

  const handleRangeChange = (dates) => {
    const [start, end] = dates;
    setSelectedDate(start);
    setTempStartDate(start);
    setTempEndDate(end);

    if (start && end) {
      const diffInDays = Math.floor((end - start) / (1000 * 60 * 60 * 24));
      if (diffInDays < minDuration || diffInDays > maxDuration) {
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'error',
            description: 'selectDurationBetween',
            intlValues: { minDuration, maxDuration },
          },
        });
        return;
      }
    }

    setError('');
    setSelectedEndDate(end);
  };

  const handleDateChange = (selectedDate) => setSelectedDate(!selectedDate ? minDate : selectedDate);

  return (
    <div className={styles.wrapper}>
      <ResourceSelectionSection laundryResources={laundryResources} />
      <ShouldRender condition={isLoading}>
        <Loader />
      </ShouldRender>
      <ShouldRender condition={laundrySchedules?.scheduleType === 'slots'}>
        <InlineDatePicker
          isInline
          selectedDate={isBefore(selectedDate, minDate) ? minDate : selectedDate}
          minDate={minDate}
          maxDate={maxDate}
          dateFormat={daysFormat}
          onChange={handleDateChange}
        />
      </ShouldRender>
      <ShouldRender condition={laundrySchedules?.scheduleType === 'daily'}>
        <div>
          <InlineDatePicker
            isInline
            selectsRange
            selectedDate={isBefore(selectedDate, minDate) ? minDate : selectedDate}
            startDate={tempStartDate}
            endDate={tempEndDate}
            dateFormat={daysFormat}
            onChange={handleRangeChange}
            minDate={minDate}
            maxDate={maxDate}
          />
          <Text 
            red 
            bold
          >
            {error}
          </Text>
        </div>
      </ShouldRender>
    </div>
  );
};
